import { Leaf, Mail, ArrowUpRight } from "lucide-react";
import { useLead } from "./lead-context";

export const Footer = () => {
  const { openLead } = useLead();
  return (
    <footer
      className="relative bg-sg-bg border-t border-sg-border/60 pt-20 sm:pt-28"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-12 pb-16">
          <div className="lg:col-span-7">
            <span className="text-xs uppercase tracking-[0.25em] text-sg-primary">
              Beautiful outside. Working for you inside.
            </span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight text-sg-fg max-w-lg leading-tight">
              Turn your patio into the centerpiece.
            </h2>
            <button
              onClick={() => openLead("quote")}
              data-testid="footer-cta-btn"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-sg-primary px-7 py-3.5 text-sm font-medium text-sg-bg hover:bg-sg-fg transition-colors duration-300"
            >
              Request a Quote <ArrowUpRight size={16} />
            </button>
          </div>

          <div className="lg:col-span-5 lg:pl-10 flex flex-col gap-6">
            <div className="flex items-center gap-2.5">
              <span className="grid place-items-center w-8 h-8 rounded-full bg-sg-primary text-sg-bg">
                <Leaf size={16} />
              </span>
              <span className="font-display text-lg text-sg-fg">MySolarGarden</span>
            </div>
            <p className="text-sm text-sg-muted font-light max-w-xs leading-relaxed">
              Sculptural solar-powered raised gardens for homeowners and condos
              who value craft, clean design, and smart technology.
            </p>
            <a
              href="mailto:DonHarris.solargardensystems@gmail.com"
              className="inline-flex items-center gap-2 text-sm text-sg-fg hover:text-sg-primary transition-colors duration-300"
              data-testid="footer-email"
            >
              <Mail size={15} /> DonHarris.solargardensystems@gmail.com
            </a>
          </div>
        </div>

        <div className="relative select-none overflow-hidden">
          <div className="font-display tracking-tight text-sg-fg/[0.06] text-[19vw] leading-none whitespace-nowrap">
            MySolarGarden
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-8 border-t border-sg-border/50">
          <p className="text-xs text-sg-muted">
            © {new Date().getFullYear()} MySolarGarden. All rights reserved.
          </p>
          <p className="text-xs text-sg-muted">
            Grow food · Generate power · Elevate your backyard
          </p>
        </div>
      </div>
    </footer>
  );
};
